<template>
  <div v-if="!isFaleConosco">
    <InfoUser v-if="isLogged" v-on:userData='data => emitToParent("userData",this,data)' v-bind="userData"/>
    <div class="innerContainer block">
      <Accordion v-for="(faq,index) in (faqs && faqs.length ? faqs : faqsDefault)" :onOpen="getByCategory" v-bind="faq" v-bind:key="index"/>
      <div class="divFaleConosco" v-if="isLogged">
      {{ t('NAO_ACHOU_DUVIDA') }} <span><a @click="abrirFaleConosco">{{ t('FALE_CONOSCO') }}</a></span>.
      </div>
    </div>
  </div>
  <div v-else>
    <InfoUser v-if="isLogged" v-on:userData='data => emitToParent("userData",this,data)' v-bind="userData"/>
      <div class="innerContainer">
        <h1 class="titleAjuda">{{ t('FALE_CONOSCO') }}</h1>
        <FormContato/>
        <RightColumnAds v-if="!isMobile()" :images="banners"/>
      </div>
  </div>
</template>
<style lang="scss">
 @import "../assets/scss/ajuda.scss";
</style>

<script>

import { translate } from '../services/translate.service';
import InfoUser from '@/components/InfoUser.vue'
import Accordion from '@/components/Accordion.vue'
import FormContato from '@/components/FormContato.vue'
import RightColumnAds from '@/components/RightColumnAds.vue'
import {emitToParent,scrollTop, redirect,resolvePromise,isMobile,baseUrl} from '../helpers/helpers'
import {getAllCategories,getByCategory} from '../services/faq.service'
 import {get} from '../services/image.service'
export default {
  name: 'ajuda',
  components: {
      InfoUser,
      Accordion,
      FormContato,
      RightColumnAds
  },
  methods:{
    t:translate,
    emitToParent,
    isMobile,
    getByCategory,
    atualizaFaq(data){
      data.forEach(faq=>{
        if(!this.faqsDefault) this.faqsDefault.push({category:faq.category.title,questions:[faq]})
        const
          hasCategory = this.faqsDefault.find(e=>e.category === faq.category.title ),
          index = hasCategory ? this.faqsDefault.indexOf(hasCategory) : -1
          console.log(index > -1)
          index > -1 ? this.faqsDefault[index].questions.push(faq) : this.faqsDefault.push({category:faq.category.title,questions:[faq]})          
       })
    },
    abrirFaleConosco(){
      history.pushState({},null,'/faleconosco')
      this.isFaleConosco = true
    },
    loadBanner: function() {
      if(this.banners.length) return;
      get("Ajuda").then(r => {
          this.banners = r.data.sort((a, b) => a.position - b.position);
      })
    }    
  },
  data(){
    return{
      faqsDefault:[],
      isFaleConosco: false,
      url:baseUrl,
      banners:[]
    }
  },
  props:{
    userData:{
      type:Object
    },
    isLogged:{
      type:Boolean
    },
    faqs:{
      type:Array
    },
    imagesObject:{
      type:Object
    }
  },
  created(){
    let {faqs} = this
    /*if(!faqs || !faqs.length) resolvePromise(getActiveFaqs(),({data})=>{
      this.atualizaFaq(data)
      emitToParent("updateFaq",this,data)
    },console.log,this)*/
    resolvePromise(getAllCategories(), ({data}) => {
      this.faqsDefault = data.map((v) => {
        return {
          id: v.id,
          category: v.title,
          questions: []
        }
      })
    }, console.error, this);
    console.log('this.faqs', this.faqs);
    scrollTop()
    //emitToParent("getImage",this,"Ajuda")
    this.loadBanner();
    
  },
  
}
</script>
